/* eslint-disable */
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Ic } from './devsIcons';
import b from './devsBar.module.css';

// The New dev button (CLB-079 round 7, option C): the primary action of the board.
// Desktop: an amber button at the right end of the bar; its word is a fit() fold cell (data-f="ndw") that
// folds to a "+" square (data-f="nd"), never into the ⋯ menu. Phone (<=760): the bar button hides and a
// floating button sits bottom-right instead, so it stays one tap away while the bar scrolls off.
// Rendered only when the user may add (perm.canAdd) — the caller decides.
export function NewDevButton({ onNew }) {
  return (
    <button type="button" className={b.ndb} data-f="nd" data-fk="nd" aria-label="New dev" data-tip="New dev · add a development" onClick={onNew}>
      <Ic n="plus" /><span className={`${b.cw} ${b.ndw}`} data-f="ndw"><span className={b.cn}>New dev</span></span>
    </button>
  );
}

export function NewDevFab({ onNew }) {
  // keep the last cards and the pager clear of the floating button (phone only)
  useEffect(() => {
    const mq = window.matchMedia('(max-width:760px)'); const prev = document.body.style.paddingBottom;
    const apply = () => { document.body.style.paddingBottom = mq.matches ? '136px' : prev; };
    apply(); mq.addEventListener && mq.addEventListener('change', apply);
    return () => { mq.removeEventListener && mq.removeEventListener('change', apply); document.body.style.paddingBottom = prev; };
  }, []);
  return createPortal(
    <div className={b.tok}><button type="button" className={b.fab} data-fk="fab" aria-label="New dev" onClick={onNew}><span className={b.fi}><Ic n="plus" /></span><span>New dev</span></button></div>,
    document.body
  );
}
